import { ReactNode } from 'react';
import styled from 'styled-components';

import TitleTextBase from 'inquiry/components/TitleTextBase';
import { TextComponentStyles } from 'lib/interfaces/ui-components';
import { fontFamilyCss } from 'verify/lib/utils/font-family';

const Title = styled('h1')`
  font-family: ${({ theme: { fontFamilyTitle } }) => fontFamilyCss(fontFamilyTitle)};
  color: ${({ theme }) => theme.colorFontTitle};
  font-size: ${({ theme }) => theme.fontSizeHeader};
  font-weight: ${({ theme }) => theme.headerFontWeight};
  line-height: ${({ theme }) => theme.lineHeightHeader};
  margin-bottom: ${({ theme }) => theme.headerMarginBottom};
  text-align: ${({ theme }) => theme.textAlign};
`;

type TextBaseProps = {
  className?: string;
  id?: string;
  styles?: TextComponentStyles;
  children: ReactNode;
};

const ThemedTitle = ({ styles, ...rest }: TextBaseProps) => {
  return (
    <>
      {styles != null ? (
        <TitleTextBase {...rest} styles={styles} />
      ) : (
        // Autofocus titles if they exist for a11y
        <Title {...rest} tabIndex={-1} />
      )}
    </>
  );
};

export default ThemedTitle;
